import React from "react";
import { call, put, select, takeLatest } from "redux-saga/effects";
import * as authActions from "#app/store/actions/auth";
import * as interfaceActions from "#app/store/actions/interface";
import { handleNotify } from "#app/store/sagas/jobs";
import { Api } from "laravel-request";
import { IndexedDBCache, Tracker, Url } from "finhelper";
import FileHelper from "#app/helpers/FileHelper";
import CacheHelper from "#app/helpers/cache/CacheHelper";

function* login(action) {
    try {
        const { form, success, error, obj } = action.payload;

        const promise = new Promise((resolve, reject) => {
            let request = Api.post("auth", "login", form).withoutNotify((status) => {
                return status !== 200;
            });

            if (obj) {
                request = request.withValidateForm(obj);
            }

            request.call(
                (response, status, xhr) => {
                    success(response, status, xhr);
                    resolve(response);
                },
                (errors) => {
                    console.error(errors);
                    error(errors);
                    reject(errors);
                }
            );
        });

        let response = yield promise;

        yield put(authActions.handleGetUser(response));
        yield put(authActions.handleAuth());

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        console.error(err);
    }
}

function* register(action) {
    try {
        const { form, success, error, obj, callback } = action.payload;

        const promise = new Promise((resolve, reject) => {
            let request = Api.post("auth", "register", form).withoutNotify();

            if (obj) {
                request = request.withValidateForm(obj);
            }

            request.call(
                (response, status, xhr) => {
                    Tracker.reachGoal("register_finished", {
                        //user_id: this.props.Client ? this.props.Client.id : null
                    });
                    success(response, status, xhr);
                    resolve(response);
                },
                (errors) => {
                    console.error(errors);
                    error(errors);
                    reject(errors);
                }
            );
        });

        let response = yield promise;
        yield put(authActions.handleGetUser(response));
        yield put(authActions.handleAuth());

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        console.error(err);
    }
}

function* requestRegister(action) {
    try {
        const { form, success, error, obj } = action.payload;

        const promise = new Promise((resolve, reject) => {
            let request = Api.post("auth", "request-register", form).withoutNotify();

            if (obj) {
                request = request.withValidateForm(obj);
            }

            request.call(
                (response, status, xhr) => {
                    Tracker.reachGoal("request_register_code", {
                        // //user_id: this.props.Client ? this.props.Client.id : null
                    });
                    success(response, status, xhr);
                    resolve(response);
                },
                (errors) => {
                    console.error(errors);
                    error(errors);
                    reject(errors);
                }
            );
        });
    } catch (err) {
        console.error(err);
    }
}

function* forgot(action) {
    try {
        const { form, success, error, obj } = action.payload;

        const promise = new Promise((resolve, reject) => {
            let request = Api.post("auth", "forgot", form).withoutNotify();

            if (obj) {
                request = request.withValidateForm(obj);
            }

            request.call(
                (response, status, xhr) => {
                    success(response, status, xhr);
                    resolve(response);
                },
                (errors) => {
                    console.error(errors);
                    error(errors);
                    reject(errors);
                }
            );
        });

        let response = yield promise;

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        console.error(err);
    }
}

function* requestForgot(action) {
    try {
        const { form, success, error, obj } = action.payload;

        const promise = new Promise((resolve, reject) => {
            let request = Api.post("auth", "request-forgot", form).withoutNotify();

            if (obj) {
                request = request.withValidateForm(obj);
            }

            request.call(
                (response, status, xhr) => {
                    success(response, status, xhr);
                    resolve(response);
                },
                (errors) => {
                    console.error(errors);
                    error(errors);
                    reject(errors);
                }
            );
        });
    } catch (err) {
        console.error(err);
    }
}

function* logout(action) {
    try {
        const { success, error, obj } = action.payload;

        yield put(authActions.handleLogout());
        yield put(interfaceActions.handleLogoutInterface());
        yield call(history.push, "/");

        const promise = new Promise((resolve, reject) => {
            Api.get("auth", "logout").call(
                (response) => {
                    if (response.result === "success") {
                        success();
                        resolve(response);
                    }
                },
                (errors) => {
                    console.error(errors);
                    error(errors);
                }
            );
        });

        let response = yield promise;
        yield handleNotify({ data: { jobs: [] } });
    } catch (err) {
        console.error(err);
    }
}

function* getServer(action) {
    try {
        IndexedDBCache.get(CacheHelper.SERVER_DATA).then((data) => {
            if (!data) {
                Api.makeRequest({
                    method: "GET",
                    url: process.env.REACT_APP_API_URL + "/api/v1/call/system/index",
                    success: ({ data }, status, xhr) => {
                        FileHelper.data = data;
                        IndexedDBCache.set(CacheHelper.SERVER_DATA, data);
                    },
                    error: (response) => {},
                });
            } else {
                FileHelper.data = data;
            }
        });
    } catch (err) {
        console.warn(err);
    }
}

function* getUser(action) {
    try {
        const promise = new Promise((resolve, reject) => {
            Api.makeRequest({
                method: "GET",
                url: process.env.REACT_APP_API_URL + "/api/v1/call/profile/index",
                success: (response, status, xhr) => {
                    resolve(response);
                },
                error: (response) => {
                    reject();
                },
            });
        });

        //если по токену входит, то нужно удалить его из памяти
        localStorage.removeItem("token");

        let response = yield promise;

        if (response.data?.api_token) {
            localStorage.setItem("api_token", response.data?.api_token);
        }

        yield put(authActions.handleGetUser(response));

        if (typeof action.payload === "undefined" || action.payload.load !== false) {
            yield put(authActions.handleAuth());
        }

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        let url = Url.getCurrentUrl();

        if (url.indexOf("/cabinet") !== -1) {
            //history.push('/login');
        }

        if (action.payload && typeof action.payload.fallback === "function") {
            yield call(action.payload.fallback);
        }

        console.warn(err);
    }
}

function* socketsConnecting(action) {
    //call middleware
}

function* postUser(action) {
    try {
        const { form, success, error, obj } = action.payload;

        const promise = new Promise((resolve, reject) => {
            let request = Api.post("profile", "profile", form);

            if (obj) {
                request = request.withValidateForm(obj);
            }

            request.call(
                (response, status, xhr) => {
                    success(response, status, xhr);
                    resolve(response);
                },
                (errors) => {
                    console.error(errors);
                    error(errors);
                    reject(errors);
                }
            );
        });

        let response = yield promise;

        yield put(authActions.handleGetUser(response));
        yield put(authActions.handleAuth());
    } catch (err) {
        console.error(err);
    }
}

function* handleAuth(action) {
    try {
        const state = yield select();
        if (state.auth && state.auth.data) {
            yield put(
                authActions.socketsConnecting({
                    userId: state.auth.data.id,
                    role: "crm",
                })
            );
        }

        yield put(interfaceActions.getContacts());
        yield put(interfaceActions.getClients());
        yield put(interfaceActions.getCourses());
        yield put(interfaceActions.getCurrencies());
    } catch (err) {
        console.error(err);
    }
}

export default function* watcher() {
    yield takeLatest(authActions.login, login);
    yield takeLatest(authActions.register, register);
    yield takeLatest(authActions.requestRegister, requestRegister);
    yield takeLatest(authActions.forgot, forgot);
    yield takeLatest(authActions.requestForgot, requestForgot);
    yield takeLatest(authActions.logout, logout);
    yield takeLatest(authActions.getUser, getUser);
    yield takeLatest(authActions.postUser, postUser);
    yield takeLatest(authActions.handleAuth, handleAuth);
    yield takeLatest(authActions.socketsConnecting, socketsConnecting);
}
